import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=366a8168&"
import script from "./Checkbox.vue?vue&type=script&lang=js&"
export * from "./Checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('366a8168')) {
      api.createRecord('366a8168', component.options)
    } else {
      api.reload('366a8168', component.options)
    }
    module.hot.accept("./Checkbox.vue?vue&type=template&id=366a8168&", function () {
      api.rerender('366a8168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/Checkbox.vue"
export default component.exports